import { useCallback, useEffect, useRef } from "react";
import { convertTimeInput } from "../../utils/convertTimeInput.js";
import { formatTime } from "../../utils/formatTime.js";
function useFocusActions(params) {
  const { updateComponentState, allowUnlistedValues, componentState, allowEmpty, timeFormat, options } = params;
  const componentStateRef = useRef(componentState);
  useEffect(() => {
    componentStateRef.current = componentState;
  }, [componentState]);
  const onBlur = useCallback(() => {
    const { inputValue, timeValue } = componentStateRef.current;
    const convertedTime = convertTimeInput(inputValue, timeFormat, allowEmpty);
    if (convertedTime === null && allowEmpty) {
      updateComponentState({
        selectValue: null,
        inputValue: "",
        timeValue: null
      });
      return;
    }
    if (convertedTime === "invalid" || convertedTime === null && !allowEmpty || !allowUnlistedValues && convertedTime !== null && !options.includes(convertedTime)) {
      updateComponentState({
        selectValue: timeValue,
        inputValue: timeValue !== null ? formatTime(timeValue, timeFormat) : ""
      });
    } else {
      updateComponentState({
        timeValue: convertedTime,
        selectValue: convertedTime,
        inputValue: timeValue !== null ? formatTime(timeValue, timeFormat) : ""
      });
    }
  }, [updateComponentState, allowUnlistedValues, timeFormat, allowEmpty, options]);
  const onFocus = useCallback((e) => {
    e.target.select();
  }, []);
  return { onBlur, onFocus };
}
export {
  useFocusActions
};
//# sourceMappingURL=useFocusActions.js.map
